module.exports = __webpack_public_path__ + "static/media/tanky.d77594de.png";